<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tabelasPreco.content"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="tabelasPreco.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma tabela encontrada"
      loading-text="Carregando tabelas..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        {{ item.codigoInterno || item.id }}
      </template>
      <template v-slot:item.fornecedor.nome="{ item }">
        <div>
          <px-span-tooltip top
                           :text="fornecedor(item)"
                           :tooltip="item.fornecedor.pessoa.nome"/>
        </div>
      </template>
      <template v-slot:item.vigencia="{ item }">
        {{ item.dataVigenciaInicial | date }} - {{ item.dataVigenciaFinal | date }}
      </template>
      <template v-slot:item.situcacao="{ item }">
        <px-ativo small :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <div class="text-right">
          <v-btn icon @click="goToTabela(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon
                 @click="onClickDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    tabelasPreco: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          sortable: false,
          value: 'id',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Fornecedor',
          value: 'fornecedor.nome',
        },
        {
          text: 'Vigência',
          value: 'vigencia',
        },
        {
          text: 'Situação',
          value: 'situcacao',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    fornecedor() {
      return item => Vue.filter('truncate')(item.fornecedor.pessoa.nome, 25);
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta tabela de preço?',
        'Esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    goToTabela(item) {
      this.$router.push({
        name: 'main.tabelas-preco.edicao',
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
